var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [
      _vm._v(
        _vm._s(_vm.$t("workflow.vueFormBuilder.elements.file.model.accept"))
      )
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.accept,
          expression: "accept"
        }
      ],
      staticClass: "form-control",
      attrs: {
        placeholder: _vm.$t(
          "workflow.vueFormBuilder.elements.file.acceptExample"
        )
      },
      domProps: { value: _vm.accept },
      on: {
        input: function($event) {
          if ($event.target.composing) return
          _vm.accept = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }